import { AideAudienceStubPage } from '../../../../components/aides/AideAudienceStubPage';
import { getAideTertiaireStub } from '../../../../config/aides-tertiaire';

export default function OptimisationTurpePage() {
  const aide = getAideTertiaireStub('optimisation-turpe');
  if (!aide) return null;
  return <AideAudienceStubPage aide={aide} audienceId="tertiaire" />;
}
